
import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import {environment} from "../../../environments/environment"

@Injectable({ providedIn: 'root' })
export class ConfigService {

    _apiURI: string;
    _photoURL: string;
    _siteURI: string;

    constructor() {
        //testing
        //this._apiURI = 'http://192.168.1.119/api.nesiyatova/api/';
        //this._photoURL = 'http://192.168.1.119/api.nesiyatova/AdsPhoto/'; 
        //this._siteURI = 'http://localhost:62592/';

        //prdoction
        this._apiURI = environment.apiURL;
        this._photoURL = 'https://api.nesiyatova.com/AdsPhoto/';
        this._siteURI = 'https://nesiyatova.com/';
    }

    getApiURI() {
        return this._apiURI;
    }

    getPhotoURL() {
        return this._photoURL;
    }

    getSiteURI() {
        return this._siteURI;
    }

    createHeader(headers: HttpHeaders) {

        let authToken = localStorage.getItem('token');
        var headers =   headers.append('Authorization', `Bearer ${authToken}`);
        return headers;
    }
}
